import AbstractListView from '@UI/Store/AbstractListView';
import type AiModelView from '@UI/Store/AiConfiguration/Views/AiModelView';

/**
 * Immutable View: `readonly` properties, frozen at the end of the constructor.
 * `scopeId` names the account this catalogue belongs to, same convention as `AiProvidersListView`.
 */
class AiModelsListView extends AbstractListView<AiModelView> {
	readonly scopeId: number;

	constructor(list: readonly AiModelView[], scopeId: number) {
		super(list, 'AiModelsListView');

		this.scopeId = scopeId;

		Object.freeze(this);
	}

	add(model: AiModelView): AiModelsListView {
		return new AiModelsListView([...this.list, model], this.scopeId);
	}

	update(model: AiModelView): AiModelsListView {
		return new AiModelsListView(
			this.list.map((entry) => (entry.id === model.id ? model : entry)),
			this.scopeId,
		);
	}

	remove(modelId: number): AiModelsListView {
		return new AiModelsListView(
			this.list.filter((entry) => entry.id !== modelId),
			this.scopeId,
		);
	}
}

export default AiModelsListView;
